import React from 'react';
import cn from 'classnames';
import { IIconProps } from './IIconProps';

export const FilterIcon = ({
	iconClass = '',
	title = '',
	style = {},
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 12 10"
			fill="none"
			style={style}
			className={cn('icon', iconClass)}
		>
			{title && <title>{title}</title>}
			<path d="M0 1H12M2 5L10 5M4 9L8 9" stroke="#25D9B8" strokeWidth="1.5" />
		</svg>
	);
};
